@use "../../style/variables" as *;

.error {
  margin-top: 2rem;
  font-size: 1rem;
  text-align: center;
  font-weight: bold;
  margin-left: 1rem;
  margin-right: 1rem;
  color: $blue-info;
}